import { Injectable } from "@angular/core";
import {
  Endpoint,
  IApiResponse,
  IHttpGetTenantTier,
  IHttpLogin,
} from "src/app/models";
import { HttpService } from "../http.service";
import { HTTP_METHOD } from ".";

@Injectable({
  providedIn: "root",
})
export class LoginApiService {
  #login = "Login" as Endpoint;
  #getTenantTier = "GetTenantTier" as Endpoint;

  constructor(private http: HttpService) {}

  /**
   * "Login" occurs after Firebase auth to retrieve user details from cloud DB
   * @returns {Promise<IApiResponse<IHttpLogin>>} User data
   */
  async userLogin(): Promise<IApiResponse<IHttpLogin>> {
    return this.http.request<IHttpLogin>(
      HTTP_METHOD.POST,
      this.#login,
      null,
      {},
      true
    );
  }

  /**
   * Get the current users tenant tier data
   * @returns {Promise<IApiResponse<IHttpGetTenantTier>>} Tenant tier and defect count
   */
  async getTenantTier(
    userId: number,
    tenantId: number
  ): Promise<IApiResponse<IHttpGetTenantTier>> {
    return this.http.request<IHttpGetTenantTier>(
      HTTP_METHOD.GET,
      this.#getTenantTier,
      { tenantId, userId },
      null
    );
  }
}
